import { ref } from 'vue';

export const use5Clicks = () => {
  let timerId: number | null = null;
  const clickCount = ref(0);

  const clear = () => {
    if (timerId) {
      clearInterval(timerId);
      clickCount.value = 0;
      timerId = null;
    }
  };

  /**
   * Method to call a callback after 5 clicks in 1 second
   */
  const onClick = (callback: () => void) => {
    clickCount.value += 1;
    if (clickCount.value >= 5) {
      callback();
      clear();
    } else if (!timerId) {
      timerId = setTimeout(() => {
        clickCount.value = 0;
        clear();
      }, 1000);
    }
  };

  return {
    clear,
    onClick,
  };
};
